function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M117.634 232.01C57.0516 230.49 8.45842 181.027 8.45842 120.227C8.45842 58.4767 58.5741 8.38 120.489 8.38C182.341 8.38 232.52 58.4133 232.52 120.227C232.52 121.937 232.456 123.583 232.393 125.293L240.64 125.483C240.703 123.773 240.767 122 240.767 120.227C240.767 53.9167 186.908 0.146666 120.489 0.146666C54.07 0.146666 0.211548 53.9167 0.211548 120.227C0.211548 185.587 52.5475 238.723 117.634 240.243V232.01Z",
  fill: "#FFCC00"
});

var SvgLoaderBigYellow = function SvgLoaderBigYellow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 241,
    viewBox: "0 0 241 241",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoaderBigYellow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loader_big_yellow.38c18205.svg";
export { ForwardRef as ReactComponent };